import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const rolesAdapter = createEntityAdapter({})

const initialState = rolesAdapter.getInitialState()

export const roleApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getroles: builder.query({
            query: () => ({
                url: '/roles',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedroles = responseData.map(role => {
                    // console.log(role)
                    role.id = role._id
                    // console.log(role)
                    return role
                });
                return rolesAdapter.setAll(initialState, loadedroles)
            },
            providesTags: (result, error, arg) => {
                console.log(result.ids) 
                if (result?.ids) {
                    return [
                        { type: 'ROLE', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'ROLE', id }))
                    ]
                } else return [{ type: 'ROLE', id: 'LIST' }]
            }
        }),
        addNewrole: builder.mutation({
            query: initialUserData => ({
                url: '/roles',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'ROLE', id: "LIST" }
            ]
        }),
        updaterole: builder.mutation({
            query: initialUserData => ({
                url: '/roles',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ROLE', id: arg.id }
            ]
        }),        
        deleterole: builder.mutation({
            query: ({ id }) => ({
                url: `/roles`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'ROLE', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetrolesQuery,
    useAddNewroleMutation,
    useUpdateroleMutation,
    useDeleteroleMutation, 
} = roleApiSlice

// returns the query result object
export const selectrolesResult = roleApiSlice.endpoints.getroles.select()

// creates memoized selector
const selectrolesData = createSelector(
    selectrolesResult,
    rolesResult => rolesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllroles,
    selectById: selectroleById,
    selectIds: selectroleIds
    // Pass in a selector that returns the users slice of state
} = rolesAdapter.getSelectors(state => selectrolesData(state) ?? initialState)